/**
 * Created by slava on 14/8/17
 */

const AvailableMove = function () {
    cleverapps.EventEmitter.call(this);

    this.paused = {};
    this.move = undefined;

    AvailableMove.REGISTERED_ALGORITHMS.sort((a, b) => (b.priority || 0) - (a.priority || 0));

    cleverapps.focusManager.on("changeFocus", () => {
        if (cleverapps.focusManager.isFocused()) {
            this.pause("focus");
        } else {
            this.resume("focus");
        }
    });

    cleverapps.userStatus.on("active", this.restartInactiveHint.bind(this));
};

AvailableMove.prototype = Object.create(cleverapps.EventEmitter.prototype);
AvailableMove.prototype.constructor = AvailableMove;

AvailableMove.prototype.clear = function () {
    this.move = undefined;
    this.paused = {};

    this.clearTimeout();
    this.purge();
};

AvailableMove.prototype.pause = function (cause = "default") {
    this.paused[cause] = true;

    if (this.isPaused()) {
        this.restartInactiveHint();
    }
};

AvailableMove.prototype.resume = function (cause = "default") {
    delete this.paused[cause];

    if (!this.isPaused()) {
        this.restartInactiveHint();
    }
};

AvailableMove.prototype.isPaused = function () {
    return Object.keys(this.paused).length > 0;
};

AvailableMove.prototype.startHint = function (move) {
    this.move = move;
    this.trigger(move.type, move);
};

AvailableMove.prototype.stopHint = function () {
    if (this.move) {
        this.move = undefined;
        this.trigger("hide");
    }
};

AvailableMove.prototype.clearTimeout = function () {
    if (this.timeout) {
        cleverapps.timeouts.clearTimeout(this.timeout);
        this.timeout = undefined;
    }
};

AvailableMove.prototype.restartInactiveHint = function () {
    this.clearTimeout();
    this.stopHint();

    if (this.isPaused() || cleverapps.tutorial.isActive() || cleverapps.config.adminMode || cleverapps.environment.isAtlasAnalyzerScene()) {
        return;
    }

    const findHint = () => {
        this.clearTimeout();

        const move = this.findMove();
        if (move) {
            this.startHint(move);
            return;
        }

        this.timeout = cleverapps.timeouts.setTimeout(findHint, AvailableMove.RETRY_HINT_TIMEOUT);
    };

    this.timeout = cleverapps.timeouts.setTimeout(findHint, AvailableMove.INACTIVE_HINT_TIMEOUT);
};

AvailableMove.prototype.findMove = function () {
    for (let i = 0; i < AvailableMove.REGISTERED_ALGORITHMS.length; ++i) {
        const algorithm = AvailableMove.REGISTERED_ALGORITHMS[i];

        if (algorithm.available && !cleverapps.user.checkAvailable(algorithm.available)) {
            continue;
        }

        const move = algorithm.findMove();
        if (move) {
            move.algorithm = algorithm;
            return move;
        }
    }
};

AvailableMove.prototype.onAfterResize = function () {
    this.restartInactiveHint();
};

AvailableMove.INACTIVE_HINT_TIMEOUT = 500; // pure technical delay, do not change it in order to get better animation !!!
AvailableMove.RETRY_HINT_TIMEOUT = 5000;

AvailableMove.REGISTERED_ALGORITHMS = [];
